import { render, staticRenderFns } from "./CompanyW9CR.vue?vue&type=template&id=2ef741ea&scoped=true&"
import script from "./CompanyW9CR.vue?vue&type=script&lang=ts&"
export * from "./CompanyW9CR.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef741ea",
  null
  
)

export default component.exports